<template>
    <main id="mainCtrl">
        <div class="promo">
            <div class="promo__data">
                <div class="promo__title">Онлайн-запись на прием</div>
                <div class="promo__markers">
                  <div class="promo__marker promo__marker_red">
                        Интеграция с МедФлекс
                    </div>
                </div>
                <div class="promo__text">
                    <p>
                        Включите интеграцию с сервисом МедФлекс, чтобы пациенты записывались на прием онлайн через наш сайт.
                    </p>
                    <ul>
                        <li>Запись на прием круглосуточно</li>
                        <li>Интеграция с вашей МИС/CRM</li>
                        <li>Выгрузка расписаний врача</li>
                        <li>Онлайн-запись пациентов</li>
                        <li>Уведомления о новых записях</li>
                    </ul>
                </div>
                <div class="promo__actions">
                    <a href="https://medflex.ru/cabinet/integrations/" class="promo__btn medflexLink" target="_blank">
                        Перейти в МедФлекс
                    </a>
                </div>
            </div>
            <div class="promo__img">
                <img src="/img/online01.svg" alt="" />
            </div>
        </div>
    </main>
</template>

<script>
import LimitedDialog from "@dialogs/limited/Clinic";

export default {
    components: {
        LimitedDialog
    },
}
</script>

<style>
a.medflexLink:active, a.medflexLink:focus {
  color: #fff;
}
</style>
